namespace $ {
	export type $shm_hitalama_guide_content_page = $shm_hitalama_guide_document_data & { parent: string }
	export function $shm_hitalama_guide_content_page( title: string, parent: string, body: string ): $shm_hitalama_guide_content_page {
		return { title, parent, body: '# ' + title + '\n\n' + body.trim(), links: [] }
	}
	/** Reviewed publication pack. Runtime never overwrites an existing authored page. */
	export class $shm_hitalama_guide_content extends $mol_object {
		static pages(): Record<string, $shm_hitalama_guide_content_page> {
			return { ...this.$.$shm_hitalama_guide_content_sections.pages(), ...this.$.$shm_hitalama_guide_content_interface.pages(), ...this.$.$shm_hitalama_guide_content_maps.pages(), ...this.$.$shm_hitalama_guide_content_data.pages(), ...this.$.$shm_hitalama_guide_content_recipes.pages() }
		}
	}
}
